import { render, staticRenderFns } from "./manage-providers.vue?vue&type=template&id=686c7c48&scoped=true"
import script from "./manage-providers.vue?vue&type=script&lang=js"
export * from "./manage-providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686c7c48",
  null
  
)

export default component.exports